import { render, staticRenderFns } from "./LedgerRelated.vue?vue&type=template&id=10dfc0f4"
import script from "./LedgerRelated.vue?vue&type=script&lang=js"
export * from "./LedgerRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports